import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountCompaniesRoutes = [
  {
    path: 'companies',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Companies')
      },
      permissions: ['READ_COMPANIES']
    },
    children: [
      {
        path: '',
        name: 'companiesList',
        component: wrapLegacyRoute('companiesController', 'list')
      },
      {
        path: 'create',
        name: 'companyCreate',
        component: wrapLegacyRoute('companiesController', 'create')
      },
      {
        path: ':companyId(\\d+)',
        name: 'companyDetails',
        component: wrapLegacyRoute('companiesController', 'details')
      }
    ]
  }
];

export default accountCompaniesRoutes;
